export default "__VITE_ASSET__nhBReMzH__"